import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EmailLog } from '../email-log';
import { SafeHTMLPipe } from '../safe-html.pipe';
import { FormatDateTimePipe } from '../format-date-time.pipe';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-email-view',
    templateUrl: './email-view.component.html',
    styleUrls: ['./email-view.component.css'],
    imports: [NgFor, NgIf, FormatDateTimePipe, SafeHTMLPipe]
})
export class EmailViewComponent implements OnInit {

  // Inputs and Outputs
  @Input() emailLog: EmailLog;

  constructor(public modal: NgbActiveModal) { }

  ngOnInit(): void {
    
  }
}
